import { FC, ReactNode } from 'react';

import { Tooltip } from 'antd';

import { selectClientTier } from 'features/auth/authSelectors';

import { useAppSelector } from 'hooks/useTypedRedux';

import { ClientTiers } from 'constants/enums';
import { useTranslation } from 'react-i18next';

interface OfferActionButtonWrapperProps {
  children: ReactNode;
  isEnabled: boolean;
}

const OfferActionButtonWrapper: FC<OfferActionButtonWrapperProps> = ({
  children,
  isEnabled
}: OfferActionButtonWrapperProps) => {
  const { t } = useTranslation()
  const currentTier = useAppSelector(selectClientTier);

  if (isEnabled) {
    return <>{children}</>;
  }

  return (
    <Tooltip
      title={
        currentTier === ClientTiers.Concierge
          ? t('sidebar.application.offer.action.tooltip.concierge')
          : t('sidebar.application.offer.action.tooltip.general')
      }
    >
      {children}
    </Tooltip>
  );
};

export default OfferActionButtonWrapper;
